// Arquivo público servido pela API fora do /v1 (ex.: logo da empresa, gravado como
// "public/logos/..."). Usa o host do REACT_APP_API_ENDPOINT, com ou sem "/" no fim,
// para o local buscar na API local e produção na API de produção.
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "http://localhost:3044/v1/";

export function apiFileUrl(path, endpoint = API_ENDPOINT) {
  return new URL(`/${String(path).replace(/^\/+/, "")}`, endpoint).href;
}
